<template>
  <div class="new-employee">
    <div class="columns is-multiline">
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Nombre"
          label-for="privateName"
        >
          <BInput
            id="privateName"
            v-model="privateName"
            placeholder="Rafaeli Camposorio Ruízo"
            icon="account"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('name', $event)"
          />
        </BField>
      </div>
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Email"
          label-for="privateEmail"
        >
          <BInput
            id="privateEmail"
            v-model="privateEmail"
            placeholder="correo@mail.com"
            icon="email"
            type="email"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('email', $event)"
          />
        </BField>
      </div>
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="CURP"
          label-for="privateCurp"
        >
          <BInput
            id="privateCurp"
            v-model="privateCurp"
            placeholder="CABL840215MDFSRS01"
            icon="human-male"
            :pattern="curpPattern"
            :disabled="loading"
            :loading="loading"
            @input="onInput('curp', $event)"
          />
        </BField>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NewBasicEmployee',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      privateName: '',
      privateEmail: '',
      privateCurp: '',
      curpPattern: '[A-Z][AEIOUX][A-Z]{2}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[MH]([ABCMTZ]S|[BCJMOT]C|[CNPST]L|[GNQ]T|[GQS]R|C[MH]|[MY]N|[DH]G|NE|VZ|DF|SP)[BCDFGHJ-NP-TV-Z]{3}[0-9A-Z][0-9]',
    };
  },
  beforeDestroy() {
    this.$store.commit('employee/setValues', {
      name: '',
      email: '',
      curp: '',
    });
  },
  methods: {
    onInput(name, event) {
      this.$store.commit('employee/setValue', { accessor: name, value: event });
    },
  },
};
</script>

<style scoped>
.field.has-addons.unionized .control {
  width: 50%;
}
</style>

<style>
.unionized-radiobutton .b-radio {
  width: 100%;
}
</style>
